export default "__VITE_ASSET__BWhdM6de__"